import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddToKbIcon } from '../../../../assets/icons/ask-ai-knowledgebase/add-to-kb-apps-icon.svg';
import { useDirectAnswer } from '../../../../redux/hooks/answer/direct-answers-hooks';
import { useAppDispatch } from '../../../../redux/hooks/app-hooks';
import { openAskAiAddKnowledgeModal } from '../../../../redux/thunks/ask-ai-kb-thunk';
import { isDirectAnswerReady } from '../../../AskAiKnowledge/AddKnowledgeButton/helper';
import { Tooltip } from '../../../Tooltips/Tooltip';
import { IAppActionsProps } from '../AppActions';

import styles from '../Actions.module.scss';

export type AddToKbProps = Partial<IAppActionsProps>;

export const AddToKb: React.FC<AddToKbProps> = ({ appInvocation }) => {
    const { t } = useTranslation('translations');
    const dispatch = useAppDispatch();
    const { directAnswer, isLoading } = useDirectAnswer();

    const isReady = !!directAnswer && isDirectAnswerReady(directAnswer);

    const handleClick: React.MouseEventHandler<HTMLOrSVGElement> = (e) => {
        e.stopPropagation();

        if (isLoading || !isReady) {
            return;
        }

        let meta: Record<string, unknown> = {};

        if (appInvocation) {
            meta = {
                app_id: appInvocation.app_id,
                invocation_id: appInvocation.invocation_id,
            };
        }

        dispatch(openAskAiAddKnowledgeModal(directAnswer ?? null, meta));
    };

    return (
        <Tooltip label={t('ask-ai-kb.validate-answer')} placement="top-end" hasArrow>
            <AddToKbIcon onClick={handleClick} className={styles.action} />
        </Tooltip>
    );
};
